(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mdc-brand-marquee')) {
    customElements.define('mdc-brand-marquee', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        const control = this.querySelector('.mdc-brand-marquee__pause');
        if (!control) return;
        control.addEventListener('click', () => {
          const paused = this.toggleAttribute('data-paused');
          control.setAttribute('aria-pressed', String(paused));
          control.setAttribute('aria-label', paused ? this.dataset.resumeLabel : this.dataset.pauseLabel);
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mdc-client-voices"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (root.dataset.mdcClientVoicesReady === 'true') return;

      const viewport = root.querySelector('[data-mdc-client-voices-viewport]');
      const previous = root.querySelector('[data-mdc-client-voices-prev]');
      const next = root.querySelector('[data-mdc-client-voices-next]');

      if (!viewport) return;

      root.dataset.mdcClientVoicesReady = 'true';

      const track = viewport.querySelector('.mdc-client-voices__track');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let animationFrame;
      let previousTimestamp;
      let pointerPaused = false;
      let userPaused = false;
      let isVisible = !('IntersectionObserver' in window);
      let hasOverflow = false;
      let scrollPosition = viewport.scrollLeft;
      const pause = root.querySelector('[data-mdc-client-voices-pause]');
      pause?.addEventListener('click', () => {
        userPaused = !userPaused;
        pause.setAttribute('aria-pressed', String(userPaused));
        pause.setAttribute('aria-label', userPaused ? 'Reprendre les témoignages' : 'Mettre les témoignages en pause');
        pause.querySelector('span').textContent = userPaused ? '▶' : 'Ⅱ';
        restart();
      });
      let manualPauseUntil = 0;
      let loopWidth = 0;

      const originalCards = track ? Array.from(track.children) : [];
      const duplicateCards = originalCards.map((card) => {
        const duplicate = card.cloneNode(true);
        duplicate.setAttribute('aria-hidden', 'true');
        duplicate.removeAttribute('data-shopify-editor-block');
        duplicate.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
        track.appendChild(duplicate);
        return duplicate;
      });

      const measureLoop = () => {
        if (!originalCards.length || !duplicateCards.length) {
          loopWidth = 0;
          hasOverflow = false;
          return;
        }

        loopWidth = duplicateCards[0].offsetLeft - originalCards[0].offsetLeft;
        hasOverflow = viewport.scrollWidth > viewport.clientWidth + 8;
      };

      measureLoop();

      const canAutoscroll = () => (
        root.isConnected
        && isVisible
        && !document.hidden
        && !userPaused
        && !reducedMotion.matches
        && loopWidth > 0
        && hasOverflow
      );

      const step = (direction) => {
        const distance = Math.min(424, Math.max(260, viewport.clientWidth * 0.78));
        manualPauseUntil = performance.now() + 3000;

        if (direction < 0 && viewport.scrollLeft <= 1 && loopWidth > 0) {
          viewport.scrollLeft += loopWidth;
        }

        viewport.scrollBy({ left: direction * distance, behavior: 'smooth' });
      };

      previous?.addEventListener('click', () => step(-1));
      next?.addEventListener('click', () => step(1));

      viewport.addEventListener('pointerdown', () => {
        pointerPaused = true;
        manualPauseUntil = performance.now() + 3000;
      });
      viewport.addEventListener('pointerup', () => {
        pointerPaused = false;
        previousTimestamp = undefined;
      });
      viewport.addEventListener('pointercancel', () => {
        pointerPaused = false;
        previousTimestamp = undefined;
      });
      viewport.addEventListener('wheel', () => {
        manualPauseUntil = performance.now() + 3000;
      }, { passive: true });

      const animate = (timestamp) => {
        if (!canAutoscroll()) {
          animationFrame = undefined;
          previousTimestamp = undefined;
          return;
        }

        if (previousTimestamp === undefined) previousTimestamp = timestamp;
        const elapsed = Math.min(timestamp - previousTimestamp, 48);
        previousTimestamp = timestamp;

        if (!pointerPaused && !userPaused && !document.hidden && performance.now() >= manualPauseUntil) {
          scrollPosition = (scrollPosition + elapsed * 0.018) % loopWidth;
          viewport.scrollLeft = scrollPosition;
        } else {
          scrollPosition = viewport.scrollLeft;
        }

        animationFrame = window.requestAnimationFrame(animate);
      };

      const start = () => {
        if (!animationFrame && canAutoscroll()) {
          animationFrame = window.requestAnimationFrame(animate);
        }
      };

      const restart = () => {
        if (animationFrame) window.cancelAnimationFrame(animationFrame);
        animationFrame = undefined;
        previousTimestamp = undefined;
        scrollPosition = viewport.scrollLeft;
        if (pause) pause.hidden = reducedMotion.matches;
        start();
      };

      if ('IntersectionObserver' in window) {
        const visibilityObserver = new IntersectionObserver((entries) => {
          isVisible = entries[0].isIntersecting;
          restart();
        });
        visibilityObserver.observe(viewport);
      }
      document.addEventListener('visibilitychange', restart);
      reducedMotion.addEventListener?.('change', restart);
      window.addEventListener('resize', () => {
        measureLoop();
        restart();
      });
      if (pause) pause.hidden = reducedMotion.matches;
      start();
    };

    document.querySelectorAll('[data-mdc-client-voices]').forEach(initialize);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mdc-design-inspirations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mdc-design-inspirations')) {
    customElements.define('mdc-design-inspirations', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.dialog = this.querySelector('dialog');
        this.content = this.querySelector('[data-mdc-dialog-content]');
        if (!this.dialog || !this.content || typeof this.dialog.showModal !== 'function') return;
        this.initialized = true;
        this.addEventListener('click', (event) => {
          const tile = event.target.closest('[data-mdc-inspiration]');
          if (!tile || !this.contains(tile) || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          const template = this.querySelector(`[id="${tile.dataset.mdcInspiration}"]`);
          if (!template) return;
          event.preventDefault();
          this.opener = tile;
          this.content.replaceChildren(template.content.cloneNode(true));
          this.dialog.showModal();
        });
        this.querySelector('[data-mdc-close]').addEventListener('click', () => this.dialog.close());
        this.dialog.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const box = this.dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
        });
        this.dialog.addEventListener('close', () => {
          this.content.replaceChildren();
          if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
        });
      }
      disconnectedCallback() {
        if (this.dialog?.open) this.dialog.close();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mdc-family-guides"] && !Shopify.designMode) return;
  try {
    
(() => {
if (customElements.get('mdc-family-guides')) return;

class MdcFamilyGuides extends HTMLElement {
connectedCallback() {
if (this.controller) return;
this.tabs = Array.from(this.querySelectorAll('[data-family-tab]'));
this.panels = Array.from(this.querySelectorAll('[data-family-panel]'));
this.empty = this.querySelector('[data-family-empty]');
if (!this.tabs.length || !this.panels.length) return;
this.controller = new AbortController();
const options = { signal: this.controller.signal };
this.addEventListener('click', this.onClick, options);
this.addEventListener('keydown', this.onKeyDown, options);
if (window.Shopify?.designMode) document.addEventListener('shopify:block:select', this.onBlockSelect, options);
this.selectPanel(this.activePanel?.id || this.dataset.initialPanel);
this.querySelector('[data-family-tabs]').hidden = false;
this.querySelector('[data-family-links]').hidden = true;
this.setAttribute('data-ready', '');
this.dispatchEvent(new Event('mdc-guide-films:connect', { bubbles: true }));
}

disconnectedCallback() {
this.dispatchEvent(new Event('mdc-guide-films:disconnect'));
this.stopVideos();
this.controller?.abort();
this.controller = null;
}

stopVideos() {
this.dispatchEvent(new Event('mdc-guide-films:stop'));
this.querySelectorAll('video').forEach((video) => {
if (!video.paused) video.pause();
});
}

selectPanel(id, focus = false) {
const panel = this.panels.find((item) => item.id === id) || null;
if (panel !== this.activePanel) this.stopVideos();
this.activePanel = panel;
this.tabs.forEach((tab, index) => {
const selected = tab.getAttribute('aria-controls') === panel?.id;
tab.setAttribute('aria-selected', String(selected));
tab.tabIndex = selected || (!panel && index === 0) ? 0 : -1;
if (selected && focus) tab.focus();
});
this.panels.forEach((item) => {
const tab = this.tabs.find((candidate) => candidate.getAttribute('aria-controls') === item.id);
item.hidden = item !== panel;
item.setAttribute('role', 'tabpanel');
if (tab) item.setAttribute('aria-labelledby', tab.id);
item.tabIndex = item === panel ? 0 : -1;
});
if (this.empty) this.empty.hidden = Boolean(panel);
}

onClick = (event) => {
if (!(event.target instanceof Element)) return;
const tab = event.target.closest('[data-family-tab]');
if (!tab || !this.tabs.includes(tab)) return;
this.selectPanel(tab.getAttribute('aria-controls'));
};

onKeyDown = (event) => {
if (!(event.target instanceof Element) || event.altKey || event.ctrlKey || event.metaKey) return;
const tab = event.target.closest('[data-family-tab]');
const index = this.tabs.indexOf(tab);
if (index < 0) return;
const rtl = getComputedStyle(this).direction === 'rtl';
let next;
if (event.key === 'ArrowRight') next = (index + (rtl ? -1 : 1) + this.tabs.length) % this.tabs.length;
else if (event.key === 'ArrowLeft') next = (index + (rtl ? 1 : -1) + this.tabs.length) % this.tabs.length;
else if (event.key === 'Home') next = 0;
else if (event.key === 'End') next = this.tabs.length - 1;
else return;
event.preventDefault();
this.selectPanel(this.tabs[next].getAttribute('aria-controls'), true);
};

onBlockSelect = (event) => {
const panel = this.panels.find((item) => item.dataset.blockId === event.detail?.blockId);
if (!panel) return;
this.selectPanel(panel.id);
};
}

customElements.define('mdc-family-guides', MdcFamilyGuides);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mdc-in-your-home"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mdc-in-your-home')) {
    customElements.define('mdc-in-your-home', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.rail = this.querySelector('[data-home-rail]');
        this.cards = Array.from(this.querySelectorAll('[data-mdc-ambient-card]'));
        this.back = this.querySelector('[data-home-back]');
        this.forward = this.querySelector('[data-home-forward]');
        this.dialog = this.querySelector('[data-home-dialog]');
        this.dialogMedia = this.querySelector('[data-home-dialog-media]');
        this.dialogCopy = this.querySelector('[data-home-dialog-copy]');
        this.dialogHeading = this.querySelector('[data-home-dialog-heading]');
        this.closeButton = this.querySelector('[data-home-close]');
        this.previous = this.querySelector('[data-home-prev]');
        this.next = this.querySelector('[data-home-next]');
        this.position = this.querySelector('[data-home-position]');
        this.states = new Map();
        this.manualSequence = 0;
        this.querySelectorAll('[data-mdc-ambient-video]').forEach((video) => {
          const card = video.closest('[data-mdc-ambient-card]');
          const state = { video, card, button: card.querySelector('[data-mdc-ambient-toggle]'), near: false, inView: false, manual: false, manualOrder: 0, claim: false, userPaused: false, blocked: false, pending: false, allowed: false, attempt: 0 };
          this.states.set(video, state);
          video.muted = true;
          video.defaultMuted = true;
          if (state.button) state.button.hidden = false;
          video.addEventListener('playing', () => {
            if (!this.canPlay(state) || !state.allowed) { this.pauseAmbientVideo(video); return; }
            state.claim = false;
            card.setAttribute('data-has-frame', '');
            card.setAttribute('data-playing', '');
            this.updateVideoButton(state);
          }, { signal });
          video.addEventListener('pause', () => { card.removeAttribute('data-playing'); this.updateVideoButton(state); }, { signal });
          video.addEventListener('error', () => {
            state.blocked = true;
            state.claim = false;
            this.pauseAmbientVideo(video);
            card.removeAttribute('data-has-frame');
          }, { signal });
        });

        this.addEventListener('click', (event) => {
          const toggle = event.target.closest('[data-mdc-ambient-toggle]');
          if (toggle && this.contains(toggle)) {
            this.toggleVideo(this.states.get(toggle.closest('[data-mdc-ambient-card]').querySelector('video')));
            return;
          }
          const opener = event.target.closest('[data-home-open]');
          if (opener && this.contains(opener)) this.openScene(this.cards.indexOf(opener.closest('[data-mdc-ambient-card]')), opener);
        }, { signal });
        this.back.addEventListener('click', () => this.moveRail(-1), { signal });
        this.forward.addEventListener('click', () => this.moveRail(1), { signal });
        this.rail.addEventListener('scroll', () => { this.scheduleRail(); if (!this.viewObserver) this.measureVisibility(); }, { signal, passive: true });
        this.rail.addEventListener('keydown', (event) => {
          if (event.target !== this.rail || event.altKey || event.ctrlKey || event.metaKey) return;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); this.moveRail(event.key === 'ArrowLeft' ? -1 : 1); }
        }, { signal });
        this.addEventListener('mdc:ambient:state', () => this.syncPlayback(), { signal });
        this.motion.addEventListener('change', () => {
          if (this.motion.matches) this.states.forEach((state) => { state.manual = false; state.claim = false; });
          this.syncPlayback();
        }, { signal });
        navigator.connection?.addEventListener?.('change', () => {
          if (navigator.connection.saveData) this.states.forEach((state) => { state.manual = false; state.claim = false; });
          this.syncPlayback();
        }, { signal });
        document.addEventListener('visibilitychange', () => {
          this.syncPlayback();
          if (document.hidden) this.dialogMedia.querySelector('video')?.pause();
        }, { signal });
        window.addEventListener('resize', () => { this.scheduleRail(); if (!this.viewObserver) this.measureVisibility(); }, { signal, passive: true });

        if ('IntersectionObserver' in window) {
          this.nearObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => { this.states.get(entry.target).near = entry.isIntersecting; });
            this.syncPlayback();
          }, { rootMargin: '300px 250px', threshold: 0 });
          this.viewObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              const state = this.states.get(entry.target);
              state.inView = entry.isIntersecting && entry.intersectionRatio >= .4;
              if (!state.inView) { state.manual = false; state.claim = false; }
            });
            this.syncPlayback();
          }, { threshold: [0, .4, .75, 1] });
          this.states.forEach((state) => { this.nearObserver.observe(state.video); this.viewObserver.observe(state.video); });
        } else {
          window.addEventListener('scroll', () => this.measureVisibility(), { signal, passive: true });
          this.measureVisibility();
        }
        if ('ResizeObserver' in window) {
          this.railObserver = new ResizeObserver(() => this.scheduleRail());
          this.railObserver.observe(this.rail);
        }

        this.closeButton.addEventListener('click', () => this.dialog.close(), { signal });
        this.previous.addEventListener('click', () => this.navigateScene(-1), { signal });
        this.next.addEventListener('click', () => this.navigateScene(1), { signal });
        this.dialog.addEventListener('close', () => this.finishModal(), { signal });
        this.dialog.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        }, { signal });
        this.dialog.addEventListener('keydown', (event) => {
          if (event.target instanceof HTMLVideoElement || event.altKey || event.ctrlKey || event.metaKey) return;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); this.navigateScene(event.key === 'ArrowLeft' ? -1 : 1); }
        }, { signal });
        this.querySelector('[data-home-arrows]').hidden = this.cards.length < 2;
        this.scheduleRail();
        this.connectAnchor(signal);
        document.dispatchEvent(new CustomEvent('mdc:ambient-ready'));
      }

      canPlay(state) {
        return this.isConnected && state.inView && !document.hidden && !this.dialog.open &&
          (!this.hasAttribute('data-mdc-ambient-suspended') || state.claim) && !state.userPaused && !state.blocked &&
          (state.manual || !(this.motion.matches || navigator.connection?.saveData));
      }

      prepareVideo(state) {
        if (state.video.hasAttribute('src')) return;
        state.video.src = state.video.dataset.videoSrc;
        state.video.load();
      }

      syncPlayback() {
        const selected = Array.from(this.states.values()).filter((state) => this.canPlay(state)).sort((a, b) =>
          Number(b.claim) - Number(a.claim) || Number(b.manual) - Number(a.manual) || (b.manual ? b.manualOrder - a.manualOrder : 0)
        ).slice(0, 4);
        this.states.forEach((state) => {
          state.allowed = selected.includes(state);
          if (!state.allowed) { this.pauseAmbientVideo(state.video); return; }
          if (!(state.near || state.manual)) return;
          this.prepareVideo(state);
          if (!state.video.paused || state.pending) return;
          state.pending = true;
          const attempt = ++state.attempt;
          state.video.muted = true;
          state.video.play().then(() => {
            if (attempt !== state.attempt) return;
            if (!this.canPlay(state) || !state.allowed) this.pauseAmbientVideo(state.video);
          }).catch((error) => {
            if (attempt === state.attempt && error.name !== 'AbortError') state.blocked = true;
            state.claim = false;
          }).finally(() => { if (attempt === state.attempt) state.pending = false; });
        });
      }

      pauseAmbientVideo(video) {
        const state = this.states?.get(video);
        if (state) { state.attempt += 1; state.pending = false; state.allowed = false; state.claim = false; state.card.removeAttribute('data-playing'); }
        if (!video.paused) video.pause();
        if (state) this.updateVideoButton(state);
      }

      updateVideoButton(state) {
        if (!state.button) return;
        const playing = state.card.hasAttribute('data-playing');
        state.button.setAttribute('aria-pressed', String(playing));
        state.button.setAttribute('aria-label', playing ? this.dataset.labelPause : this.dataset.labelPlay);
      }

      toggleVideo(state) {
        if (!state) return;
        if (!state.video.paused || state.pending) {
          state.userPaused = true;
          state.manual = false;
          this.pauseAmbientVideo(state.video);
          return;
        }
        if (state.video.error) { state.video.removeAttribute('src'); state.video.load(); }
        state.userPaused = false;
        state.blocked = false;
        state.manual = true;
        state.manualOrder = ++this.manualSequence;
        state.claim = true;
        state.near = true;
        this.measureVisibility();
      }

      measureVisibility() {
        const rail = this.rail.getBoundingClientRect();
        this.states.forEach((state) => {
          const rect = state.video.getBoundingClientRect();
          const width = Math.max(0, Math.min(rect.right, rail.right, innerWidth) - Math.max(rect.left, rail.left, 0));
          const height = Math.max(0, Math.min(rect.bottom, rail.bottom, innerHeight) - Math.max(rect.top, rail.top, 0));
          state.inView = width * height / Math.max(1, rect.width * rect.height) >= .4;
          state.near = rect.bottom > -300 && rect.top < innerHeight + 300 && rect.right > rail.left - 250 && rect.left < rail.right + 250;
          if (!state.inView) { state.manual = false; state.claim = false; }
        });
        this.syncPlayback();
      }

      moveRail(direction) {
        const gap = Number.parseFloat(getComputedStyle(this.rail).columnGap) || 16;
        const step = (this.cards[0]?.getBoundingClientRect().width || this.rail.clientWidth) + gap;
        const count = matchMedia('(min-width: 990px)').matches ? 2 : 1;
        this.rail.scrollBy({ left: direction * step * count, behavior: this.motion.matches ? 'auto' : 'smooth' });
      }

      scheduleRail() {
        if (this.railFrame) return;
        this.railFrame = requestAnimationFrame(() => {
          this.railFrame = null;
          this.back.disabled = this.rail.scrollLeft <= 2;
          this.forward.disabled = this.rail.scrollLeft + this.rail.clientWidth >= this.rail.scrollWidth - 2;
        });
      }

      openScene(index, opener) {
        if (index < 0 || typeof this.dialog.showModal !== 'function') return;
        this.opener = opener;
        this.previousOverflow = document.documentElement.style.overflow;
        this.renderScene(index);
        this.dialog.showModal();
        this.modalWasOpen = true;
        document.documentElement.style.overflow = 'hidden';
        this.notifyModal(true);
        this.syncPlayback();
        this.startModalVideo();
        this.closeButton.focus({ preventScroll: true });
      }

      stopModalVideo() {
        this.cancelModalStart();
        const video = this.dialogMedia.querySelector('video');
        if (!video) return;
        video.pause();
        video.removeAttribute('src');
        video.load();
      }

      renderScene(index) {
        const card = this.cards[index];
        if (!card) return;
        this.stopModalVideo();
        this.sceneIndex = index;
        this.dialogMedia.replaceChildren(card.querySelector('[data-home-modal-template]').content.cloneNode(true));
        this.dialogCopy.replaceChildren();
        const copy = card.querySelector('[data-home-copy]');
        if (copy) this.dialogCopy.append(copy.cloneNode(true));
        this.dialogHeading.textContent = this.dataset.labelScene + ' ' + (index + 1);
        this.previous.disabled = index === 0;
        this.next.disabled = index === this.cards.length - 1;
        this.position.textContent = (index + 1) + ' / ' + this.cards.length;
        this.dialog.scrollTop = 0;
      }

      startModalVideo() {
        this.cancelModalStart();
        const video = this.dialogMedia.querySelector('video');
        if (!video || !this.dialog.open) return;
        const controller = new AbortController();
        this.modalStartController = controller;
        const signal = controller.signal;
        const cancel = () => this.cancelModalStart();
        const schedule = () => {
          if (signal.aborted || this.modalStartFrame != null) return;
          this.modalStartFrame = requestAnimationFrame(() => {
            this.modalStartFrame = null;
            if (signal.aborted) return;
            const canStart = this.isConnected && video.isConnected && this.dialog.open && !document.hidden &&
              this.dialogMedia.querySelector('video') === video && video.readyState >= HTMLMediaElement.HAVE_FUTURE_DATA;
            this.cancelModalStart();
            if (canStart && video.paused) video.play().catch(() => {});
          });
        };
        video.addEventListener('canplay', schedule, { once: true, signal });
        ['pointerdown', 'click', 'keydown', 'play'].forEach((type) => video.addEventListener(type, cancel, { once: true, signal }));
        document.addEventListener('visibilitychange', () => { if (document.hidden) cancel(); }, { signal });
        video.muted = true;
        video.defaultMuted = true;
        video.src = video.dataset.modalVideoSrc;
        video.load();
        if (video.readyState >= HTMLMediaElement.HAVE_FUTURE_DATA) schedule();
      }

      cancelModalStart() {
        this.modalStartController?.abort();
        this.modalStartController = null;
        if (this.modalStartFrame != null) cancelAnimationFrame(this.modalStartFrame);
        this.modalStartFrame = null;
      }

      navigateScene(direction) {
        const next = this.sceneIndex + direction;
        if (next < 0 || next >= this.cards.length) return;
        this.renderScene(next);
        this.notifyModal(true);
        this.startModalVideo();
      }

      notifyModal(open) {
        document.dispatchEvent(new CustomEvent('mdc:ambient-modal', { detail: { dialog: this.dialog, open } }));
      }

      finishModal() {
        if (!this.modalWasOpen) return;
        this.modalWasOpen = false;
        this.stopModalVideo();
        this.notifyModal(false);
        this.dialogMedia.replaceChildren();
        this.dialogCopy.replaceChildren();
        document.documentElement.style.overflow = this.previousOverflow || '';
        this.opener?.focus({ preventScroll: true });
        this.syncPlayback();
      }

      connectAnchor(signal) {
        const follow = () => {
          this.cancelAnchorFrames();
          if (!this.isConnected || location.hash !== '#' + this.id) return;
          this.anchorFirst = requestAnimationFrame(() => {
            this.anchorFirst = null;
            this.anchorSecond = requestAnimationFrame(() => {
              this.anchorSecond = null;
              if (!signal.aborted && this.isConnected && location.hash === '#' + this.id) this.scrollIntoView({ block: 'start', behavior: 'auto' });
            });
          });
        };
        window.addEventListener('hashchange', follow, { signal });
        if (document.readyState === 'complete') follow();
        else window.addEventListener('load', follow, { once: true, signal });
        signal.addEventListener('abort', () => this.cancelAnchorFrames(), { once: true });
      }

      cancelAnchorFrames() {
        if (this.anchorFirst != null) cancelAnimationFrame(this.anchorFirst);
        if (this.anchorSecond != null) cancelAnimationFrame(this.anchorSecond);
        this.anchorFirst = null;
        this.anchorSecond = null;
      }

      disconnectedCallback() {
        if (this.dialog?.open) this.dialog.close();
        this.finishModal();
        this.controller?.abort();
        this.controller = null;
        this.nearObserver?.disconnect();
        this.viewObserver?.disconnect();
        this.railObserver?.disconnect();
        if (this.railFrame) cancelAnimationFrame(this.railFrame);
        this.railFrame = null;
        this.states?.forEach((state) => {
          this.pauseAmbientVideo(state.video);
          state.video.removeAttribute('src');
          state.video.load();
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mdc-installation-guide"] && !Shopify.designMode) return;
  try {
    
(() => {
const initializeGuides = (scope) => {
scope.querySelectorAll('.mdc-install-guide__external').forEach((details) => {
if (details.dataset.mdcInitialized) return;
details.dataset.mdcInitialized = 'true';
details.addEventListener('toggle', () => {
const slot = details.querySelector('.mdc-install-guide__player');
const template = details.querySelector('template');
if (details.open && template && !slot.firstElementChild) {
slot.append(template.content.cloneNode(true));
} else if (!details.open) {
slot.replaceChildren();
}
});
});
};
initializeGuides(document);
document.addEventListener('shopify:section:load', (event) => initializeGuides(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mdc-product-resources"] && !Shopify.designMode) return;
  try {
    
  if (!window.mdcResourceShortcutsBound) {
    window.mdcResourceShortcutsBound = true;
    const matchesProduct = (purchase, productId) => {
      const form = purchase?.querySelector('product-form-component[data-product-id]');
      const picker = purchase?.querySelector('variant-picker[data-product-id]');
      return form?.dataset.productId === productId && (!picker || picker.dataset.productId === productId);
    };
    const hasTarget = (link, template) => {
      const source = template?.closest('[data-mdc-product-resources]');
      const target = document.getElementById(link.hash.slice(1));
      return source?.dataset.productId === template?.dataset.productId && Boolean(target && source?.contains(target));
    };
    const removeShortcuts = (nav) => (nav.closest('li.mdc-resource-shortcuts-item') || nav).remove();
    const refreshShortcuts = () => {
      document.querySelectorAll('[data-mdc-resource-links]').forEach((nav) => {
        const template = document.getElementById(nav.dataset.sourceTemplateId);
        const purchase = nav.closest('[id^="ProductInformation-"]');
        if (!template || !matchesProduct(purchase, template.dataset.productId)) {
          removeShortcuts(nav);
          return;
        }
        nav.querySelectorAll('a').forEach((link) => { if (!hasTarget(link, template)) link.remove(); });
        if (!nav.querySelector('a')) removeShortcuts(nav);
      });
      document.querySelectorAll('template[data-mdc-resource-shortcuts]').forEach((template) => {
        const purchase = document.getElementById(template.dataset.purchaseId);
        if (!matchesProduct(purchase, template.dataset.productId)) return;
        const points = purchase.querySelector('.mdc-pdp-points');
        if (!points) return;
        const nav = template.content.firstElementChild.cloneNode(true);
        nav.querySelectorAll('a').forEach((link) => { if (!hasTarget(link, template)) link.remove(); });
        if (!nav.querySelector('a')) return;
        const current = document.getElementById(nav.id);
        const currentItem = current?.closest('li.mdc-resource-shortcuts-item');
        if (current?.isEqualNode(nav) && currentItem) {
          if (currentItem.parentElement !== points || points.lastElementChild !== currentItem) points.append(currentItem);
          return;
        }
        if (current) removeShortcuts(current);
        const item = document.createElement('li');
        item.className = 'mdc-resource-shortcuts-item';
        item.append(nav);
        points.append(item);
      });
    };
    let refreshPending = false;
    const scheduleRefresh = () => {
      if (refreshPending) return;
      refreshPending = true;
      requestAnimationFrame(() => { refreshPending = false; refreshShortcuts(); });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refreshShortcuts, { once: true });
    else refreshShortcuts();
    document.addEventListener('shopify:section:load', scheduleRefresh);
    document.addEventListener('shopify:section:unload', scheduleRefresh);
    document.addEventListener('variant:update', scheduleRefresh);
    document.addEventListener('click', (event) => {
      const link = event.target.closest('[data-mdc-resource-links] a');
      if (!link) return;
      const nav = link.closest('[data-mdc-resource-links]');
      const template = document.getElementById(nav.dataset.sourceTemplateId);
      if (!template || !matchesProduct(nav.closest('[id^="ProductInformation-"]'), template.dataset.productId) || !hasTarget(link, template)) {
        event.preventDefault();
        removeShortcuts(nav);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mdc-product-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mdc-product-reviews')) {
    customElements.define('mdc-product-reviews', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-mdc-track]');
        if (!this.track) return;
        this.cards = Array.from(this.track.querySelectorAll('[data-mdc-review]'));
        this.previous = this.querySelector('[data-mdc-previous]');
        this.next = this.querySelector('[data-mdc-next]');
        this.controls = this.querySelector('[data-mdc-controls]');
        this.footer = this.querySelector('[data-mdc-footer]');
        this.position = this.querySelector('[data-mdc-position]');
        this.status = this.querySelector('[data-mdc-status]');
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.previous.addEventListener('click', () => this.move(-1), { signal });
        this.next.addEventListener('click', () => this.move(1), { signal });
        this.track.addEventListener('scroll', () => this.scheduleUpdate(), { passive: true, signal });
        this.track.addEventListener('keydown', (event) => {
          if (event.target !== this.track || event.altKey || event.ctrlKey || event.metaKey) return;
          const rtl = getComputedStyle(this.track).direction === 'rtl';
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
          } else if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            this.scrollToOffset(event.key === 'Home' ? 0 : this.maximumOffset());
          }
        }, { signal });
        this.addEventListener('shopify:block:select', (event) => {
          const card = event.target.closest('[data-mdc-review]');
          const index = this.cards.indexOf(card);
          if (index >= 0) this.scrollToOffset(index * this.stride(), true);
        }, { signal });
        this.observer = new ResizeObserver(() => this.scheduleUpdate());
        this.observer.observe(this.track);
        this.scheduleUpdate();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
        this.frame = null;
      }

      maximumOffset() {
        return Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      }

      stride() {
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        return (this.cards[0]?.getBoundingClientRect().width || 0) + gap;
      }

      scrollToOffset(offset, immediate = false) {
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
        const boundedOffset = Math.max(0, Math.min(this.maximumOffset(), offset));
        this.scrollToRequested = true;
        this.track.scrollTo({ left: boundedOffset * (rtl ? -1 : 1), behavior: immediate || reducedMotion ? 'instant' : 'smooth' });
      }

      move(direction) {
        this.scrollToOffset(Math.abs(this.track.scrollLeft) + direction * this.stride());
      }

      scheduleUpdate() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          const maximum = this.maximumOffset();
          const offset = Math.max(0, Math.min(maximum, Math.abs(this.track.scrollLeft)));
          const stride = this.stride();
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          const count = this.cards.length;
          const first = Math.min(count, Math.max(1, Math.round(offset / Math.max(1, stride)) + 1));
          const perView = Math.max(1, Math.floor((this.track.clientWidth + gap + 1) / Math.max(1, stride)));
          const last = Math.min(count, first + perView - 1);
          this.previous.disabled = offset <= 2;
          this.next.disabled = offset >= maximum - 2;
          this.controls.hidden = maximum <= 2;
          this.footer.hidden = maximum <= 2;
          this.position.textContent = (first === last ? first : first + '–' + last) + ' / ' + count;
          if (this.scrollToRequested) {
            this.status.textContent = first === last ? first + ' / ' + count : first + '–' + last + ' / ' + count;
          }
        });
      }
    });
  }
  if (!customElements.get('mdc-product-inspirations')) {
    customElements.define('mdc-product-inspirations', class extends HTMLElement {
      static observedAttributes = ['data-product-id', 'data-product-handle', 'data-initial-variant-id'];

      static id(value, kind) {
        if (typeof value === 'number' && !Number.isSafeInteger(value)) return '';
        const prefix = 'gid://shopify/' + kind + '/';
        const raw = String(value ?? '');
        const text = raw.startsWith(prefix) ? raw.slice(prefix.length) : raw;
        return /^[1-9]\d*$/.test(text) ? text : '';
      }

      static text(value) {
        return typeof value === 'string' ? value.trim() : '';
      }

      static imageSource(value, origin) {
        if (typeof value !== 'string' || !value.trim()) return null;
        try {
          const url = new URL(value, origin);
          const local = new URL(origin);
          if (url.protocol !== 'https:' || url.username || url.password) return null;
          if (url.hostname !== 'cdn.shopify.com' && !(url.origin === local.origin && url.pathname.startsWith('/cdn/'))) return null;
          url.hash = '';
          return { src: url.href, file: url.origin + url.pathname };
        } catch {
          return null;
        }
      }

      static responsiveImage(item) {
        const widths = [320, 480, 640, 800, 1122].filter((width) => width <= item.width);
        const maximum = Math.min(item.width, 1122);
        if (!widths.includes(maximum)) widths.push(maximum);
        const resized = (width) => {
          const url = new URL(item.src);
          url.searchParams.set('width', String(width));
          return url.href;
        };
        return {
          src: resized(Math.min(item.width, 640)),
          srcset: widths.map((width) => resized(width) + ' ' + width + 'w').join(', '),
          sizes: '(min-width: 1320px) 400px, (min-width: 990px) calc((100vw - 120px) / 3), (min-width: 750px) calc((100vw - 76px) / 2), calc(88vw - 35.2px)'
        };
      }

      static selectGallery(manifest, identity, variantId, origin) {
        if (manifest?.schema_version !== 1 || !identity?.handle || !identity?.id || !variantId) return null;
        const product = Object.hasOwn(manifest.products ?? {}, identity.handle) ? manifest.products[identity.handle] : null;
        if (!product || product.status !== 'ready' || product.product_handle !== identity.handle || this.id(product.product_id, 'Product') !== identity.id || !Array.isArray(product.sets)) return null;
        const matches = product.sets.filter((set) => set?.status === 'ready' && Array.isArray(set.variant_ids) && set.variant_ids.some((id) => this.id(id, 'ProductVariant') === variantId));
        if (matches.length !== 1) return null;
        const set = matches[0];
        if (!this.text(set.set_id) || !this.text(set.configuration_label) || set.variant_ids.some((id) => !this.id(id, 'ProductVariant')) || !Array.isArray(set.images) || set.images.length < 6) return null;
        const ids = new Set();
        const files = new Set();
        const hashes = new Set();
        const images = [];
        for (const item of set.images) {
          const source = this.imageSource(item?.src, origin);
          const imageId = this.text(item?.image_id);
          const hash = this.text(item?.sha256).toLowerCase();
          if (!source || !imageId || !/^[a-f0-9]{64}$/.test(hash) || !this.text(item.alt) || !this.text(item.caption) || !Number.isInteger(item.width) || !Number.isInteger(item.height) || item.width < 1 || item.height < 1 || ids.has(imageId) || files.has(source.file) || hashes.has(hash)) return null;
          ids.add(imageId);
          files.add(source.file);
          hashes.add(hash);
          images.push({ image_id: imageId, src: source.src, width: item.width, height: item.height, alt: item.alt.trim(), caption: item.caption.trim() });
        }
        return { set_id: set.set_id.trim(), configuration_label: set.configuration_label.trim(), variant_id: variantId, images: images.slice(0, 6) };
      }

      static selectFeedback(manifest, identity) {
        if (manifest?.schema_version !== 1 || !identity?.handle || !identity?.id || !Array.isArray(manifest.entries)) return [];
        const used = new Set();
        return manifest.entries.filter((entry) => {
          if (!entry || entry.eligible_product_display !== true || entry.validation_merchant?.status !== 'attested' || !['review', 'opinion'].includes(entry.content_kind) || !this.text(entry.id) || !this.text(entry.author) || !this.text(entry.text) || used.has(entry.id)) return false;
          const exact = entry.mapping_status === 'exact' && entry.product_handle === identity.handle && this.id(entry.product_id, 'Product') === identity.id;
          const named = entry.mapping_status === 'named_product_group' && entry.content_kind === 'opinion' && !entry.product_id && !entry.product_handle && entry.product_metrics_eligible === false && this.text(entry.scope_label) && Array.isArray(entry.display_targets) && entry.display_targets.some((target) => target?.product_handle === identity.handle && this.id(target.product_id, 'Product') === identity.id);
          if (!exact && !named) return false;
          used.add(entry.id);
          return true;
        });
      }

      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.gallery = this.querySelector('[data-mdci-gallery]');
        this.track = this.querySelector('[data-mdci-track]');
        this.previous = this.querySelector('[data-mdci-previous]');
        this.next = this.querySelector('[data-mdci-next]');
        this.controls = this.querySelector('[data-mdci-controls]');
        this.footer = this.querySelector('[data-mdci-footer]');
        this.position = this.querySelector('[data-mdci-position]');
        this.status = this.querySelector('[data-mdci-status]');
        this.configuration = this.querySelector('[data-mdci-configuration]');
        this.disclosure = this.querySelector('[data-mdci-disclosure]');
        this.feedback = this.querySelector('[data-mdci-feedback]');
        this.feedbackList = this.querySelector('[data-mdci-feedback-list]');
        this.editorNote = this.querySelector('[data-mdci-editor-note]');
        if (!this.gallery || !this.track || !this.previous || !this.next || !this.feedback || !this.feedbackList) return;
        this.generation = (this.generation ?? 0) + 1;
        this.pendingSelection = false;
        this.failedSets = new Set();
        this.identity = { id: this.constructor.id(this.dataset.productId, 'Product'), handle: this.dataset.productHandle ?? '' };
        const signal = this.controller.signal;
        document.addEventListener('change', (event) => {
          if (!this.mainPickerFrom(event.target)) return;
          this.generation += 1;
          this.pendingSelection = true;
          this.conceal();
        }, { capture: true, signal });
        document.addEventListener('shopify:product:select', (event) => this.productSelected(event), { capture: true, signal });
        window.addEventListener('popstate', () => this.historyChanged(), { signal });
        window.addEventListener('pageshow', (event) => {
          if (event.persisted) this.historyChanged();
        }, { signal });
        this.previous.addEventListener('click', () => this.move(-1), { signal });
        this.next.addEventListener('click', () => this.move(1), { signal });
        this.track.addEventListener('scroll', () => this.schedulePosition(), { passive: true, signal });
        this.track.addEventListener('scrollend', () => this.announcePosition(), { signal });
        this.track.addEventListener('keydown', (event) => this.trackKeydown(event), { signal });
        this.resizeObserver = new ResizeObserver(() => this.schedulePosition());
        this.resizeObserver.observe(this.track);
        this.dataObserver = new MutationObserver(() => this.scheduleContext());
        const data = this.querySelector('[data-mdci-data]');
        if (data) this.dataObserver.observe(data, { childList: true, characterData: true, subtree: true });
        this.scheduleContext();
      }

      disconnectedCallback() {
        this.generation = (this.generation ?? 0) + 1;
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        this.dataObserver?.disconnect();
        cancelAnimationFrame(this.positionFrame);
        cancelAnimationFrame(this.contextFrame);
        clearTimeout(this.announceTimer);
      }

      attributeChangedCallback(name, previous, current) {
        if (previous !== current && this.isConnected && this.gallery) {
          this.generation += 1;
          this.pendingSelection = false;
          this.conceal();
          this.scheduleContext();
        }
      }

      scheduleContext() {
        this.conceal();
        if (this.contextFrame) return;
        this.contextFrame = requestAnimationFrame(() => {
          this.contextFrame = null;
          if (!this.isConnected) return;
          const productId = this.constructor.id(this.dataset.productId, 'Product');
          this.identity = { id: productId, handle: this.dataset.productHandle ?? '' };
          try {
            this.manifest = JSON.parse(this.querySelector('[data-mdci-data]')?.textContent ?? '{}');
          } catch {
            this.manifest = null;
          }
          this.renderFeedback();
          if (!this.pendingSelection) this.resolveInitial();
        });
      }

      mainPickerFrom(target) {
        const picker = target instanceof Element ? target.closest('variant-picker[data-template-product-match="true"]') : null;
        return picker && !picker.closest('product-card, quick-add-dialog, featured-product-information') ? picker : null;
      }

      currentPicker() {
        const candidates = Array.from(document.querySelectorAll('variant-picker[data-template-product-match="true"]')).filter((picker) => this.mainPickerFrom(picker));
        if (candidates.length !== 1) return null;
        const picker = candidates[0];
        return this.pickerMatches(picker) ? picker : null;
      }

      pickerMatches(picker) {
        return Boolean(picker && this.identity && this.constructor.id(picker.dataset.productId, 'Product') === this.identity.id && picker.dataset.productHandle === this.identity.handle);
      }

      pickerVariant(picker) {
        try {
          const variant = JSON.parse(picker.querySelector('script[type="application/json"]')?.textContent ?? 'null');
          return variant && this.constructor.id(variant.id, 'ProductVariant');
        } catch {
          return '';
        }
      }

      urlMatches(variantId) {
        try {
          const url = new URL(window.location.href);
          const segment = decodeURIComponent(url.pathname).split('/products/')[1]?.split('/')[0];
          if (segment !== this.identity.handle) return false;
          const urlVariant = url.searchParams.get('variant');
          return !url.searchParams.has('option_values') && (!urlVariant || this.constructor.id(urlVariant, 'ProductVariant') === variantId);
        } catch {
          return false;
        }
      }

      resolveInitial() {
        if (!this.identity?.id || !this.identity?.handle || this.pendingSelection) return;
        const picker = this.currentPicker();
        let variantId = '';
        if (picker) {
          if (picker.getAttribute('aria-busy') === 'true') return;
          variantId = this.pickerVariant(picker);
          const declared = this.constructor.id(picker.dataset.mdcSelectedVariantId, 'ProductVariant');
          if (declared && declared !== variantId) return;
        } else if (this.dataset.singleVariant === 'true' && !document.querySelector('variant-picker[data-template-product-match="true"]')) {
          variantId = this.constructor.id(this.dataset.initialVariantId, 'ProductVariant');
        }
        if (variantId && this.urlMatches(variantId)) this.renderGallery(variantId);
      }

      productSelected(event) {
        const picker = this.mainPickerFrom(event.target);
        if (!picker) return;
        this.conceal();
        const generation = ++this.generation;
        this.pendingSelection = true;
        if (!this.pickerMatches(picker) || this.constructor.id(event.product?.id, 'Product') !== this.identity.id || event.product?.handle !== this.identity.handle || typeof event.promise?.then !== 'function') return;
        const context = this.identity.id + '/' + this.identity.handle;
        Promise.resolve(event.promise).then((result) => {
          if (!this.isConnected || this.generation !== generation || context !== this.identity.id + '/' + this.identity.handle) return;
          this.pendingSelection = false;
          const resource = result?.detail?.resource;
          const variantId = this.constructor.id(resource?.id, 'ProductVariant');
          const currentPicker = this.currentPicker();
          if (!variantId || this.constructor.id(result?.detail?.productId, 'Product') !== this.identity.id || !currentPicker || this.pickerVariant(currentPicker) !== variantId || !this.urlMatches(variantId)) return;
          const declared = this.constructor.id(currentPicker.dataset.mdcSelectedVariantId, 'ProductVariant');
          if (declared && declared !== variantId) return;
          this.renderGallery(variantId);
        }, () => {
          if (this.generation === generation) {
            this.pendingSelection = false;
            this.conceal();
          }
        });
      }

      historyChanged() {
        this.conceal();
        queueMicrotask(() => {
          if (this.isConnected && !this.pendingSelection) this.resolveInitial();
        });
      }

      conceal() {
        if (this.gallery) this.gallery.hidden = true;
        if (this.controls) this.controls.hidden = true;
        if (this.configuration) this.configuration.hidden = true;
        if (this.disclosure) this.disclosure.hidden = true;
        if (this.editorNote) this.editorNote.hidden = false;
        this.renderedKey = '';
        this.announceRequested = false;
        if (this.status) this.status.textContent = '';
      }

      node(tag, className, value) {
        const element = document.createElement(tag);
        if (className) element.className = className;
        if (value !== undefined) element.textContent = value;
        return element;
      }

      ratingTiles(score, className) {
        const stars = this.node('span', 'mdc-rating-tiles ' + className);
        stars.setAttribute('aria-hidden', 'true');
        if (!Number.isFinite(score) || score < 0 || score > 5) return stars;
        for (let index = 0; index < 5; index += 1) {
          const tile = this.node('span', 'mdc-rating-tiles__tile');
          const fill = Math.round(Math.min(100, Math.max(0, (score - index) * 100)) * 10) / 10;
          tile.style.setProperty('--mdc-rating-fill', String(fill) + '%');
          const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
          svg.setAttribute('viewBox', '0 0 32 32');
          svg.setAttribute('width', '20');
          svg.setAttribute('height', '20');
          svg.setAttribute('focusable', 'false');
          svg.setAttribute('aria-hidden', 'true');
          const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
          path.setAttribute('d', 'M16 4.1 19.6 11.4 27.7 12.6 21.8 18.3 23.2 26.3 16 22.5 8.8 26.3 10.2 18.3 4.3 12.6 12.4 11.4Z');
          path.setAttribute('fill', 'currentColor');
          svg.append(path);
          tile.append(svg);
          stars.append(tile);
        }
        return stars;
      }

      renderGallery(variantId) {
        const set = this.constructor.selectGallery(this.manifest, this.identity, variantId, window.location.origin);
        if (!set) return;
        const key = this.identity.id + '/' + String(this.manifest.revision ?? '') + '/' + set.set_id + '/' + variantId;
        if (this.failedSets.has(key)) return;
        const fragment = document.createDocumentFragment();
        for (const item of set.images) {
          const card = this.node('li', 'mdc-pi__card');
          const figure = this.node('figure', 'mdc-pi__figure');
          const media = this.node('div', 'mdc-pi__media');
          const img = this.node('img', 'mdc-pi__image');
          img.width = item.width;
          img.height = item.height;
          img.alt = item.alt;
          img.loading = 'lazy';
          img.decoding = 'async';
          img.addEventListener('error', () => {
            if (this.renderedKey === key) {
              this.failedSets.add(key);
              this.conceal();
            }
          }, { once: true, signal: this.controller.signal });
          const responsive = this.constructor.responsiveImage(item);
          img.sizes = responsive.sizes;
          img.srcset = responsive.srcset;
          img.src = responsive.src;
          media.append(img);
          figure.append(media);
          card.append(figure);
          fragment.append(card);
        }
        this.track.replaceChildren(fragment);
        this.cards = Array.from(this.track.children);
        this.configuration.textContent = set.configuration_label;
        this.configuration.hidden = false;
        if (this.disclosure) this.disclosure.hidden = false;
        this.renderedKey = key;
        this.gallery.hidden = false;
        if (this.editorNote) this.editorNote.hidden = true;
        this.track.scrollTo({ left: 0, behavior: 'instant' });
        this.schedulePosition();
      }

      renderFeedback() {
        const entries = this.constructor.selectFeedback(this.manifest, this.identity);
        this.feedback.hidden = entries.length === 0;
        this.feedbackList.dataset.singleEntry = String(entries.length === 1);
        this.renderFeedbackList(this.feedbackList, entries, 'product');
      }

      renderFeedbackList(list, entries, scope) {
        list.replaceChildren();
        const fragment = document.createDocumentFragment();
        for (const [index, entry] of entries.entries()) {
          const card = this.node('li', 'mdc-pi__feedback-card');
          card.dataset.entryId = entry.id;
          const article = this.node('article', 'mdc-pi__feedback-article');
          const author = this.node('p', 'mdc-pi__feedback-author', entry.author.trim());
          author.id = 'MdcProductFeedbackAuthor-' + this.dataset.sectionId + '-' + scope + '-' + index;
          article.setAttribute('aria-labelledby', author.id);
          article.append(this.node('p', 'mdc-pi__feedback-kind', entry.content_kind === 'opinion' ? 'Impression sur le design' : 'Avis client'));
          const byline = this.node('div', 'mdc-pi__feedback-byline');
          byline.append(author);
          if (Number.isFinite(entry.rating) && entry.rating >= 1 && entry.rating <= 5) {
            const rating = this.node('span', 'mdc-pi__feedback-rating');
            const label = String(entry.rating).replace('.', ',');
            rating.setAttribute('role', 'img');
            rating.setAttribute('aria-label', label + ' sur 5 étoiles' + (entry.content_kind === 'opinion' ? ' pour le design' : ''));
            const stars = this.ratingTiles(entry.rating, 'mdc-pi__feedback-stars');
            const number = this.node('span', 'mdc-pi__feedback-rating-value', label + ' / 5');
            number.setAttribute('aria-hidden', 'true');
            rating.append(stars, number);
            byline.append(rating);
          }
          article.append(byline, this.node(entry.content_kind === 'review' ? 'blockquote' : 'p', 'mdc-pi__feedback-text', entry.text.trim()));
          if (entry.mapping_status === 'named_product_group' && this.constructor.text(entry.scope_label)) article.append(this.node('p', 'mdc-pi__feedback-scope', entry.scope_label.trim()));
          card.append(article);
          fragment.append(card);
        }
        list.append(fragment);
      }

      maximumOffset() {
        return Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      }

      stride() {
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        return (this.cards?.[0]?.getBoundingClientRect().width || 0) + gap;
      }

      scrollToOffset(offset) {
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
        const bounded = Math.max(0, Math.min(this.maximumOffset(), offset));
        this.announceRequested = true;
        this.track.scrollTo({ left: bounded * (rtl ? -1 : 1), behavior: reducedMotion ? 'instant' : 'smooth' });
        this.schedulePosition();
        clearTimeout(this.announceTimer);
        this.announceTimer = setTimeout(() => this.announcePosition(), 450);
      }

      move(direction) {
        this.scrollToOffset(Math.abs(this.track.scrollLeft) + direction * this.stride());
      }

      trackKeydown(event) {
        if (event.target !== this.track || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          this.scrollToOffset(event.key === 'Home' ? 0 : this.maximumOffset());
        }
      }

      schedulePosition() {
        if (this.positionFrame || !this.gallery || this.gallery.hidden) return;
        this.positionFrame = requestAnimationFrame(() => {
          this.positionFrame = null;
          if (!this.isConnected || this.gallery.hidden) return;
          const maximum = this.maximumOffset();
          const offset = Math.max(0, Math.min(maximum, Math.abs(this.track.scrollLeft)));
          const stride = Math.max(1, this.stride());
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          const count = this.cards.length;
          const first = Math.min(count, Math.max(1, Math.round(offset / stride) + 1));
          const perView = Math.max(1, Math.floor((this.track.clientWidth + gap + 1) / stride));
          const last = Math.min(count, first + perView - 1);
          this.previous.disabled = offset <= 2;
          this.next.disabled = offset >= maximum - 2;
          this.controls.hidden = maximum <= 2;
          this.footer.hidden = maximum <= 2;
          this.position.textContent = (first === last ? first : first + '–' + last) + ' / ' + count;
          this.positionAnnouncement = first === last ? 'Image ' + first + ' sur ' + count : 'Images ' + first + ' à ' + last + ' sur ' + count;
        });
      }

      announcePosition() {
        if (this.announceRequested && !this.gallery.hidden) {
          this.status.textContent = this.positionAnnouncement ?? '';
          this.announceRequested = false;
          clearTimeout(this.announceTimer);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mdc-trust-ticker"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mdc-trust-ticker')) {
    customElements.define('mdc-trust-ticker', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.viewport = this.querySelector('[data-mdc-ticker-viewport]');
        this.track = this.querySelector('[data-mdc-ticker-track]');
        this.messages = this.querySelector('[data-mdc-ticker-messages]');
        this.button = this.querySelector('[data-mdc-ticker-toggle]');
        this.label = this.querySelector('[data-mdc-ticker-label]');
        if (!this.viewport || !this.track || !this.messages || !this.button || !this.label) return;
        this.controller = new AbortController();
        this.userPaused = this.userPaused || false;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.copy = this.messages.cloneNode(true);
        this.copy.removeAttribute('data-mdc-ticker-messages');
        this.copy.setAttribute('aria-hidden', 'true');
        this.copy.inert = true;
        this.track.appendChild(this.copy);
        const signal = this.controller.signal;
        this.button.addEventListener('click', () => {
          this.userPaused = !this.userPaused;
          this.syncPlayback();
        }, { signal });
        this.motion.addEventListener('change', () => this.refreshMotion(), { signal });
        document.addEventListener('visibilitychange', () => this.syncPlayback(), { signal });
        this.resizeObserver = new ResizeObserver(() => this.measure());
        this.resizeObserver.observe(this.viewport);
        this.resizeObserver.observe(this.messages);
        this.refreshMotion();
        document.fonts.ready.then(() => {
          if (this.isConnected) this.measure();
        });
      }

      refreshMotion() {
        const reduce = this.motion.matches;
        this.button.hidden = reduce;
        if (reduce) {
          this.removeAttribute('data-ready');
        } else {
          this.measure();
        }
        this.syncPlayback();
      }

      measure() {
        if (!this.isConnected || this.motion.matches) return;
        const width = this.viewport.clientWidth;
        if (!width) return;
        this.style.setProperty('--mdc-ticker-viewport', `${width}px`);
        this.dataset.ready = 'true';
        this.style.setProperty('--mdc-ticker-travel', `-${this.messages.getBoundingClientRect().width}px`);
      }

      syncPlayback() {
        const label = this.userPaused ? this.dataset.resumeLabel : this.dataset.pauseLabel;
        this.dataset.userPaused = String(this.userPaused);
        this.dataset.paused = String(this.userPaused || document.hidden || this.motion.matches);
        this.button.setAttribute('aria-label', label);
        this.label.textContent = label;
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        this.copy?.remove();
        this.removeAttribute('data-ready');
        if (this.button) this.button.hidden = true;
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mdc-video-moments"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mdc-video-moments')) {
    customElements.define('mdc-video-moments', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
        this.states = Array.from(this.querySelectorAll('[data-moment-card]')).map((card) => ({
          card,
          video: card.querySelector('[data-moment-video]'),
          control: card.querySelector('[data-moment-control]'),
          status: card.querySelector('[data-moment-status]'),
          visible: false,
          manuallyPaused: false,
          failed: false,
          autoBlocked: false,
          manualPlay: false,
          intendsPlay: false
        })).filter((state) => state.card.dataset.boundProductId === this.dataset.productId);

        this.states.forEach((state) => {
          state.video.muted = true;
          state.video.defaultMuted = true;
          state.video.loop = true;
          state.video.playsInline = true;

          state.control.addEventListener('click', () => {
            if (!state.video.paused && !state.video.ended) {
              state.manuallyPaused = true;
              this.pause(state);
              return;
            }
            state.manuallyPaused = false;
            state.failed = false;
            state.autoBlocked = false;
            state.card.removeAttribute('data-error');
            state.status.textContent = '';
            this.loadSource(state);
            if (state.video.error) state.video.load();
            this.play(state, true);
          }, { signal });

          state.video.addEventListener('playing', () => {
            if (!state.intendsPlay || document.hidden) {
              this.pause(state);
              return;
            }
            state.card.setAttribute('data-started', '');
            state.card.setAttribute('data-playing', '');
            state.card.removeAttribute('data-error');
            state.control.setAttribute('aria-label', state.control.dataset.pauseLabel);
            state.control.setAttribute('aria-pressed', 'true');
          }, { signal });

          state.video.addEventListener('pause', () => {
            state.card.removeAttribute('data-playing');
            state.control.setAttribute('aria-label', state.failed ? state.control.dataset.retryLabel : state.control.dataset.playLabel);
            state.control.setAttribute('aria-pressed', 'false');
          }, { signal });

          state.video.addEventListener('error', () => this.showError(state), { signal });
        });

        if ('IntersectionObserver' in window) {
          this.nearObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              const state = this.states.find((candidate) => candidate.card === entry.target);
              if (state) this.loadSource(state);
              this.nearObserver.unobserve(entry.target);
            });
          }, { rootMargin: '350px 0px', threshold: 0 });

          this.visibleObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              const state = this.states.find((candidate) => candidate.card === entry.target);
              if (!state) return;
              state.visible = entry.isIntersecting && entry.intersectionRatio >= .35;
              this.synchronize(state);
            });
          }, { rootMargin: '0px', threshold: [0, .35, .7] });

          this.states.forEach((state) => {
            this.nearObserver.observe(state.card);
            this.visibleObserver.observe(state.card);
          });
        }

        document.addEventListener('visibilitychange', () => {
          this.states.forEach((state) => this.synchronize(state));
        }, { signal });

        window.addEventListener('pagehide', () => {
          this.states.forEach((state) => this.pause(state));
        }, { signal });

        this.motionPreference.addEventListener('change', () => {
          this.states.forEach((state) => this.synchronize(state));
        }, { signal });

        this.connection?.addEventListener?.('change', () => {
          this.states.forEach((state) => this.synchronize(state));
        }, { signal });

        this.setAttribute('data-ready', '');
        this.connectAnchorNavigation(signal);
      }

      connectAnchorNavigation(signal) {
        const followHash = () => {
          this.cancelAnchorFrames();
          if (!this.isConnected || window.location.hash !== '#' + this.id) return;
          this.anchorFirstFrame = requestAnimationFrame(() => {
            this.anchorFirstFrame = null;
            this.anchorSecondFrame = requestAnimationFrame(() => {
              this.anchorSecondFrame = null;
              if (!signal.aborted && this.isConnected && window.location.hash === '#' + this.id) {
                this.scrollIntoView({ block: 'start', behavior: 'auto' });
              }
            });
          });
        };
        window.addEventListener('hashchange', followHash, { signal });
        if (document.readyState === 'complete') {
          followHash();
        } else {
          window.addEventListener('load', followHash, { once: true, signal });
        }
        signal.addEventListener('abort', () => this.cancelAnchorFrames(), { once: true });
      }

      cancelAnchorFrames() {
        if (this.anchorFirstFrame != null) cancelAnimationFrame(this.anchorFirstFrame);
        if (this.anchorSecondFrame != null) cancelAnimationFrame(this.anchorSecondFrame);
        this.anchorFirstFrame = null;
        this.anchorSecondFrame = null;
      }

      automaticPlaybackAllowed() {
        return !this.motionPreference.matches && !this.connection?.saveData;
      }

      loadSource(state) {
        if (state.video.hasAttribute('src')) return;
        const source = state.video.dataset.src;
        if (!source || state.card.dataset.boundProductId !== this.dataset.productId) return;
        state.video.src = source;
      }

      synchronize(state) {
        if (document.hidden || !state.visible) {
          this.pause(state);
          return;
        }
        if (!this.automaticPlaybackAllowed()) {
          if (!state.manualPlay) this.pause(state);
          return;
        }
        if (!state.manuallyPaused && !state.failed && !state.autoBlocked) {
          this.play(state, false);
        }
      }

      play(state, manual) {
        if (!this.isConnected || document.hidden) return;
        if (!manual && (!state.visible || !this.automaticPlaybackAllowed() || state.manuallyPaused || state.failed || state.autoBlocked)) return;
        if (!state.video.paused && state.intendsPlay) return;
        this.loadSource(state);
        if (!state.video.hasAttribute('src')) return;
        state.video.muted = true;
        if (manual) state.manualPlay = true;
        state.intendsPlay = true;
        const attempt = state.video.play();
        if (!attempt?.then) return;
        attempt.then(() => {
          if (!this.isConnected || document.hidden || !state.intendsPlay) state.video.pause();
        }).catch((error) => {
          if (!this.isConnected || !state.intendsPlay || error?.name === 'AbortError') return;
          state.intendsPlay = false;
          state.card.removeAttribute('data-playing');
          if (error?.name === 'NotAllowedError') {
            state.autoBlocked = true;
            state.control.setAttribute('aria-label', state.control.dataset.playLabel);
            state.control.setAttribute('aria-pressed', 'false');
            return;
          }
          this.showError(state);
        });
      }

      pause(state) {
        state.intendsPlay = false;
        state.manualPlay = false;
        state.video.pause();
      }

      showError(state) {
        if (!this.isConnected) return;
        state.failed = true;
        state.intendsPlay = false;
        state.video.pause();
        state.card.removeAttribute('data-playing');
        state.card.setAttribute('data-error', '');
        state.control.setAttribute('aria-label', state.control.dataset.retryLabel);
        state.control.setAttribute('aria-pressed', 'false');
        state.status.textContent = this.dataset.errorLabel;
      }

      disconnectedCallback() {
        this.states?.forEach((state) => {
          state.intendsPlay = false;
          state.video.pause();
        });
        this.controller?.abort();
        this.controller = null;
        this.nearObserver?.disconnect();
        this.visibleObserver?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
